/* eslint-disable array-callback-return */
/**
 * 消息盒子组件
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useCallback, useRef, useEffect, useState, useMemo } from "react";
import { MessageDateFormType } from "@/types/chat/enum";
import "./index.less";
import { ChatMessage, Session } from "@/types/chat";
import ChatMessageItem from "@/components/chat/message/Item/ChatItem";
import { getMessageDateFormat } from "@/utils/date";
import { MessageEmitCategory } from "@jd/jdee.im.sdk/lib/es/enum/MessageEmitType";
import SysMessageItem from "@/components/chat/message/Item/SysItem";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import SysMessage from "@/components/chat/message/Sys";
import { useTranslation } from "react-i18next";
import Revoke from "@/components/chat/message/Revoke";
import Context from "@/components/chat/context";
import bus from "@/utils/bus";
import RefreshMessageBox from "../../handler/countDownHandler";
import ImService from "@/server/ImService";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import AIGreeting from "@/baseComponents/Chat/AIGreeting";
import { TYPE_KEY_SHARE_GREET_MULTI } from "@/contant/chat";

interface MessageBoxProps {
  messages: ChatMessage[];
  session?: Session;
  sText?: string;
  sMid?: number;
  observer?: IntersectionObserver;
  getLock: Function;
  unLock: Function;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  unreadFistMsgId: number;
}
interface DvaDispatchProps {
  updateSessionMessageMid: Function;
  updateSessionMessagesTimestamp: Function;
  setVoiceMessageMap: Function;
  dealStopQuestions: Function;
}

let visbol: boolean;
type IProps = Readonly<MessageBoxProps & DvaDispatchProps & ChatState>;
function MessageBox(props: IProps) {
  // const { messages, session, sText = '', sMid = -1 } = props;
  const { messages, session, setVoiceMessageMap, sText = "", sMid = -1, unreadFistMsgId } = props;
  const { groupRosterIdentity, isLiveMeetingChat } = React.useContext(Context);
  const { t } = useTranslation("chat");
  const ref = useRef<HTMLDivElement | null>(null);

  const [contentHeight, setContentHeight] = useState(0); // 内容高度
  const [loaded, setLoaded] = useState(false); // 初次加载
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!props.observer) {
      return;
    }
    const observer = new MutationObserver(([entry]) => {
      if (entry.type === "attributes") {
        const hiddenAttr = !!ref.current?.classList.contains("hidden");
        if (hiddenAttr) {
          // setTimeout(() => {
          if (ref.current?.clientHeight) {
            setContentHeight(ref.current?.clientHeight);
          }
          // }, 100);
        }
        setHidden(hiddenAttr);
      }
    });
    ref.current &&
      observer.observe(ref.current, {
        attributes: true
      });
    return () => {
      observer && observer.disconnect();
    };
  }, [props.observer]);

  useEffect(() => {
    const curr = ref.current;
    setLoaded(true);
    curr && props.observer && props.observer.observe(curr);
    return () => {
      curr && props.observer && props.observer.unobserve(curr);
    };
  }, [props.observer]);

  useEffect(() => {
    if (loaded && ref.current?.clientHeight) {
      setContentHeight(ref.current?.clientHeight);
    }
  }, [loaded]);

  /**
   * strat 阅后即焚
   * 只有当前会话是单聊密聊会话，才去初始化倒计时实例和可见区域监听实例
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const refreshMessageBox = session?.isSecret ? new RefreshMessageBox() : null;

  useEffect(() => {
    refreshMessageBox?.startTimer();
    return () => {
      refreshMessageBox?.clearTimer();
      refreshMessageBox?.destroy();
    };
  }, [refreshMessageBox]);

  /**
   * end 阅后即焚
   */

  // 语音转文字
  useEffect(() => {
    return () => {
      setVoiceMessageMap([]);
    };
  }, [setVoiceMessageMap]);

  const getSendTime = useCallback(
    (message) => {
      const sendTime = getMessageDateFormat(
        message.timestamp,
        MessageDateFormType.DATE_AGGREGATION
      );
      return <div className="time">{sendTime}</div>;
    },
    [t] // eslint-disable-line
  );

  useEffect(() => {
    bus.off("message:Box");
    bus.on("message:Box", (data) => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      visbol = data;
    });
  }, []);
  if (messages.length > 0) {
    const ids = messages.map((m: any) => m.id).join(",");
    return (
      <div
        ref={ref}
        className="message-node"
        style={{ marginTop: messages[0].type === "unified_notice_message" ? "0px" : "8px" }}
      >
        {hidden ? (
          <div className="chat-box-skeleton" style={{ height: contentHeight }} data-id={ids}>
            <div className="skeleton-avatar" />
            <div className="skeleton-content">
              <div className="skeleton-title" />
              <div className="skeleton-text" />
            </div>
          </div>
        ) : (
          messages.map((message: any, index) => {
            if (message.category === MessageEmitCategory.SYSTEM) {
              // 这里过滤了flag=100的会议消息，卡片内部不需要再处理
              if (
                message.type === ChatMessageType.SYS &&
                message.flag !== 100 &&
                !message.data?._sys_msg_type_
              ) {
                return <SysMessage key={`s-2-${message.id}`} message={message} />;
              } else {
                return <SysMessageItem key={`s-${message.id}`} message={message} />;
              }
            } else if (
              [MessageEmitCategory.CHAT_MESSAGE, MessageEmitCategory.LIVE_CHAT_MESSAGE].includes(
                message.category
              )
            ) {
              if (message.revoke === 1 && !message.plusList) {
                return (
                  <Revoke
                    key={`r-${message.id}`}
                    message={message}
                    sessionType={session?.sessionType}
                  />
                );
              } else if (message.type === ChatMessageType.PERMISSION_CHANGE) {
                return null;
              } else if (message.type === TYPE_KEY_SHARE_GREET_MULTI) {
                return <AIGreeting message={message} />;
              } else {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%"
                    }}
                    className={
                      visbol === true && !message.mid && message.type === ChatMessageType.TEXT
                        ? "mergeUp"
                        : ""
                    }
                  >
                    {!!unreadFistMsgId && message.id === unreadFistMsgId ? (
                      <div className="new-msgs-line" id="id-new-msgs-line">以下是最新消息</div>
                    ) : null}
                    <ChatMessageItem
                      key={`c-${message.id}-${message.timestamp}`}
                      groupRosterIdentity={groupRosterIdentity}
                      sendTime={getSendTime(messages[0])}
                      prevMessage={index > 0 ? messages[index - 1] : null}
                      message={message}
                      getLock={props.getLock}
                      unLock={props.unLock}
                      getCurrentMessageId={props.getCurrentMessageId}
                      setCurrentMessageId={props.setCurrentMessageId}
                      sText={sText}
                      sMid={sMid}
                      refreshMessageBox={refreshMessageBox}
                      updateSessionMessageMid={props.updateSessionMessageMid}
                      dealStopQuestions={props.dealStopQuestions}
                      updateSessionMessagesTimestamp={props.updateSessionMessagesTimestamp}
                      isLiveMeetingChat={isLiveMeetingChat}
                    />
                  </div>
                );
              }
            } else {
              return null;
            }
          })
        )}
      </div>
    );
  }
  return null;
}

function mapStateToProps({ chat }: any) {
  const { selectedSession } = chat as ChatState;

  return { selectedSession };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    dealStopQuestions(data: any) {
      dispatch({ type: "chat/dealStopQuestions", payload: data });
    },
    updateSessionMessagesTimestamp(data: { timestamp: number }) {
      dispatch({ type: "chat/updateSessionMessagesTimestamp", payload: data });
    },
    setVoiceMessageMap(payload: boolean) {
      dispatch({ type: "chat/setVoiceMessageMap", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MessageBox);
